function request (key, options, timeout) {
  return new Promise((resolve, reject) => {
    if (check()) {
      const id = makeid(8)
      const handler = event => {
        if (event?.data?.response && event?.data?.response === key && event?.data?.id === id) {
          resolve(event.data.payload)
          
          window.removeEventListener('message', handler)
        }
      }

      window.addEventListener('message', handler)
      window.parent.postMessage({ request: key, id, options }, '*')

      if (timeout) {
        setTimeout(reject, timeout)
      }
    } else {
      reject()
    }
  })
}

function listen (key, callback) {
  window.addEventListener('message', event => {
    if (event.data.event === key && callback) {
      callback(event.data.payload)
    }
  })
}

function check () {
  const params = new URLSearchParams(window.location.search)

  return params.get('cap') !== null
}

function makeid (length) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  let counter = 0

  while (counter < length) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
    counter += 1
  }

  return result
}

export default {
  request,
  listen,
  check
}